export default __webpack_public_path__ + "static/media/Korrigerad.a469fce6.png";